import { useEffect, useState } from "react";
import { getPacks, startCheckout } from "../api";
import { track } from "../lib/analytics";
import { useSession } from "../state";

type Pack = { id: string; name: string; tokens: number; amount_cents: number };

export function Buy() {
  const { token } = useSession();
  const [packs, setPacks] = useState<Pack[]>([]);
  const [busy, setBusy] = useState<string | null>(null);
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    (async () => {
      const t = await token();
      if (!t) return;
      try { setPacks(await getPacks(t)); } catch (e: any) { setErr(e.message); }
    })();
  }, [token]);

  const buy = async (id: string) => {
    setBusy(id); setErr(null);
    try {
      const t = (await token())!;
      track("checkout_started", { pack: id });
      const { url } = await startCheckout(t, id);
      window.location.assign(url);
    } catch (e: any) {
      setErr(e.message || "couldn't start checkout");
      setBusy(null);
    }
  };

  return (
    <div className="mt-6 max-w-3xl mx-auto">
      <h2 className="font-display font-black text-3xl">get tokens</h2>
      <p className="text-ink-soft mb-8">1 token = 1 unwatermarked render. tokens never expire.</p>

      <div className="grid sm:grid-cols-3 gap-4">
        {packs.map((p) => {
          const dollars = (p.amount_cents / 100).toFixed(2);
          const each = (p.amount_cents / p.tokens / 100).toFixed(2);
          const isFeatured = p.id === "five";
          return (
            <button
              key={p.id}
              onClick={() => buy(p.id)}
              disabled={!!busy}
              className={`relative text-left p-5 rounded-3xl transition active:scale-[0.98] ${
                isFeatured
                  ? "bg-coral text-white shadow-soft hover:bg-coral-dark"
                  : "bg-cream-dark/60 hover:bg-cream-dark text-ink"
              } disabled:opacity-50`}
            >
              {isFeatured && (
                <span className="absolute -top-2 right-4 text-[10px] uppercase tracking-wider bg-amber text-ink px-2 py-0.5 rounded-full">
                  popular
                </span>
              )}
              <div className="font-display font-black text-2xl">{p.tokens} {p.tokens === 1 ? "token" : "tokens"}</div>
              <div className={`text-3xl font-display font-black mt-1 ${isFeatured ? "" : "text-coral-dark"}`}>${dollars}</div>
              <div className={`text-xs mt-1 ${isFeatured ? "text-white/80" : "text-ink-soft"}`}>${each} each</div>
              <div className="mt-4 text-sm">{busy === p.id ? "redirecting…" : "buy"}</div>
            </button>
          );
        })}
      </div>

      {err && <p className="text-coral-dark mt-4">{err}</p>}

      <p className="text-xs text-ink-mute mt-8">
        secure checkout via stripe. cards never touch our servers.
      </p>
    </div>
  );
}
